import { render, staticRenderFns } from "./orderbalances.vue?vue&type=template&id=4df3bbb8&"
import script from "./orderbalances.vue?vue&type=script&lang=js&"
export * from "./orderbalances.vue?vue&type=script&lang=js&"
import style0 from "./orderbalances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports